module.exports = __webpack_public_path__ + "img/af_get.c219f66.png";